import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropdownModel } from '../../../dropdown/dropdown.model';
import { COMPONENT_MODE } from '../../../workflow-components.models';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { FormControl, Validators } from '@angular/forms';
import { startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BERetailInventoryInputService } from '../be-retail-inventory-input.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'be-retail-inventory-input-articles-dialog',
    templateUrl: './be-retail-inventory-input-articles-dialog.component.html',
    styleUrls: ['./be-retail-inventory-input-articles-dialog.component.scss']
})
export class BERetailInventoryInputArticlesDialog implements OnInit {
    searchFormControl = new FormControl('');
    control = new FormControl(null, [Validators.required]);
    datasFiltered: any[] = [];

    constructor(
        public dialogRef: MatDialogRef<BERetailInventoryInputArticlesDialog>,
        @Inject(MAT_DIALOG_DATA) private data: { datas: any[], valueName: string, displayName: string },
        private _inventoryInputService: BERetailInventoryInputService,
    ) {
    }

    ngOnInit() {
        this.searchFormControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
        ).subscribe(async searchValue => {
            if (searchValue != '' && searchValue.length > 2) {
                this.datasFiltered = await this._inventoryInputService.doGetBaseEtamDatasAction({ SearchValue: searchValue }).toPromise();
            }
        });
        /*this.datasFiltered = this.searchFormControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
            switchMap(val => { return this.filter(val || '')})       
        );*/
    }

    /*filter(val: string): Observable<any[]> {
        // call the service which makes the http-request
        var queryParams: any = {
            SearchValue: val
        };
        return this._inventoryInputService.doGetBaseEtamDatasAction(queryParams).pipe(map(response => response.filter(option => { return option.name.toLowerCase().indexOf(val.toLowerCase()) === 0})))
    } */ 
    
    dismiss() {
        this.dialogRef.close(false);
    }

    onValueChanged(event: MatSelectChange) {
        const item = this.datasFiltered.find(d => d.CODE_BARRE == event.value);
        this.control.patchValue(item);
    }

    onSubmit() {
        if (!this.control.valid) { return; }
        this.dialogRef.close(this.control.value);
    }
}